import React from 'react';
interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  action?: React.ReactNode;
}
export function EmptyState({
  icon,
  title,
  description,
  action
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center px-6 py-12 text-center" data-id="element-5210" data-mp="1oe1lcbjmktms">
      <div aria-hidden className="flex h-12 w-12 items-center justify-center rounded-full border border-line bg-canvas text-ink-muted" data-id="element-5211" data-mp="1sevaf88t0eh9">
        {icon}
      </div>
      <p className="mt-4 text-h4 font-semibold text-ink" data-id="element-5212" data-mp="10mw4pu5v1xbf">{title}</p>
      <p className="mt-1.5 max-w-[46ch] text-body text-ink-muted" data-id="element-5213" data-mp="10l1jeeqog36t">{description}</p>
      {action && <div className="mt-4" data-id="element-5214" data-mp="14mwjjfwvgaj0">{action}</div>}
    </div>;
}